/**
 * Client-side mirror of the server's `resolveCancellationReasonLabel`
 * (api-server lib/cancellation-labels.ts). Produces the single human-readable
 * cancellation reason label for the admin Trip Detail view using the graceful
 * fallback chain:
 *
 *   free-text detail → resolved reason name → `Reason #N` → "No reason given"
 *
 * The free-text `cancelled_details` always wins when present; the canonical
 * reason name (resolved server-side from `cancellation_reasons`) is next; a
 * missing / inactive reason row degrades to `Reason #<id>` so the raw code is
 * still visible; and a row with neither falls back to "No reason given".
 */
export function resolveCancellationReasonLabel(input: {
  detail?: string | null;
  reasonName?: string | null;
  reasonId?: number | string | null;
}): string {
  const detail = (input.detail ?? "").toString().trim();
  if (detail) return detail;
  const name = (input.reasonName ?? "").toString().trim();
  if (name) return name;
  if (input.reasonId != null && String(input.reasonId).trim() !== "") {
    return `Reason #${input.reasonId}`;
  }
  return "No reason given";
}
